export default {
  apiVersion: (state) => state.version
}



// WEBPACK FOOTER //
// ./src/store/getters.js